import script from "./ContactEmail.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactEmail.vue?vue&type=script&setup=true&lang=js"

import "./ContactEmail.vue?vue&type=style&index=0&id=bd6c66aa&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd6c66aa"]])

export default __exports__